var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-content"},[_c('widget-header',[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('widget-body',[_vm._t("default",function(){return [_c('widget-indicator',{attrs:{"value":_vm.count}})]})],2),_c('widget-footer',[_vm._t("footer")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }